import changeCurrentLocation from 'actions/lib/change_current_location';
import Snippet, { SnippetContent, SnippetChannels } from 'models/answers/snippet';
import SnippetEditor from 'models/location/snippet_editor';

export default class SwitchSnippetNew {
  constructor(context) {
    this.context = context;
  }

  run() {
    this.updateCurrentLocation();
    this.setSnippetComposition();
  }

  updateCurrentLocation() {
    changeCurrentLocation(this.context, SnippetEditor.create({ snippetId: null }));
  }

  setSnippetComposition() {
    let snippet = Snippet.create({
      contents: [
        SnippetChannels.create({
          anyChannel: SnippetContent.create(),
          info: SnippetContent.create(),
          message: SnippetContent.create(),
          selfService: SnippetContent.create(),
          language: 'en-us',
        }),
      ],
    });
    this.context.stores.snippetComposition.set(snippet);
    this.context.stores.snippetComposition.clearErrors();
    this.context.stores.snippetComposition.resetPending();
  }
}
